import { JSX } from 'react'

import { IconProps } from '../../icon'

const Edit: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 48 48'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <path
      d='M38.6826 9.31742C36.926 7.56085 34.0531 7.56085 32.2965 9.31742L21.1661 20.4479C20.6244 20.9896 20.3289 21.7119 20.3289 22.4835V26.4399C20.3289 27.113 20.887 27.6711 21.5601 27.6711H25.5165C26.2881 27.6711 27.0104 27.3757 27.5521 26.8339L38.6826 15.7035C40.4392 13.9469 40.4392 11.074 38.6826 9.31742ZM25.812 25.0937C25.812 25.0937 25.6314 25.2087 25.5165 25.2087H22.7913V22.4835C22.7913 22.3686 22.8406 22.2701 22.9063 22.188L30.8355 14.2588L33.7412 17.1645L25.812 25.0937ZM36.9424 13.9633L35.4978 15.408L32.592 12.5022L34.0367 11.0576C34.8411 10.2532 36.138 10.2532 36.9424 11.0576C37.7468 11.862 37.7468 13.1589 36.9424 13.9633Z'
      fill='black'
    />
    <path
      d='M33.8561 22.7626C33.183 22.7626 32.6249 23.3207 32.6249 23.9938V33.8438C32.6249 35.8794 30.9668 37.5375 28.9311 37.5375H14.1562C12.1206 37.5375 10.4625 35.8794 10.4625 33.8438V19.0688C10.4625 17.0332 12.1206 15.3751 14.1562 15.3751H24.0062C24.6792 15.3751 25.2374 14.817 25.2374 14.1439C25.2374 13.4708 24.6792 12.9126 24.0062 12.9126H14.1562C10.758 12.9126 8 15.6706 8 19.0688V33.8438C8 37.242 10.758 40 14.1562 40H28.9311C32.3294 40 35.0873 37.242 35.0873 33.8438V23.9938C35.0873 23.3207 34.5292 22.7626 33.8561 22.7626Z'
      fill='black'
    />
  </svg>
)

export default Edit
